import React from 'react';
import Icon from '../../../components/AppIcon';

const VerificationError = ({ errorMessage, onContinueToLogin, onResendVerification }) => {
  return (
    <div className="clinical-card p-8 text-center">
      {/* Error Icon */}
      <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <Icon name="XCircle" size={48} color="#ef4444" />
      </div>
      {/* Error Message */}
      <h1 className="text-3xl font-bold text-foreground mb-3">
        Verification Failed
      </h1>
      <p className="text-muted-foreground mb-6">
        {errorMessage}
      </p>
      {/* Common Issues Panel */}
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-6 text-left">
        <h2 className="text-lg font-semibold text-foreground mb-3 flex items-center gap-2">
          <Icon name="AlertCircle" size={20} color="#f59e0b" />
          Common Issues
        </h2>
        
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li className="flex items-start gap-2">
            <Icon name="Clock" size={16} color="#6b7280" className="mt-0.5 flex-shrink-0" />
            <span>Verification link may have expired (valid for 24 hours)</span>
          </li>
          <li className="flex items-start gap-2">
            <Icon name="Link" size={16} color="#6b7280" className="mt-0.5 flex-shrink-0" />
            <span>Link may have already been used</span>
          </li>
          <li className="flex items-start gap-2">
            <Icon name="Mail" size={16} color="#6b7280" className="mt-0.5 flex-shrink-0" />
            <span>Email may not have been copied correctly</span>
          </li>
        </ul>
      </div>
      {/* Action Buttons */}
      <div className="space-y-3">
        {onResendVerification && (
          <button
            onClick={onResendVerification}
            className="w-full px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors font-semibold flex items-center justify-center gap-2"
          >
            <Icon name="RefreshCw" size={18} color="white" />
            Resend Verification Email
          </button>
        )}
        
        <button
          onClick={onContinueToLogin}
          className="w-full px-6 py-3 bg-background border-2 border-border text-foreground rounded-lg hover:bg-muted transition-colors font-semibold"
        >
          Return to Login
        </button>
      </div>
      {/* Support Contact */}
      <div className="mt-6 pt-6 border-t border-border">
        <p className="text-sm text-muted-foreground mb-2">
          Still having trouble?
        </p>
        <a
          href="/contact-support"
          className="text-primary hover:underline font-semibold text-sm flex items-center justify-center gap-1"
        >
          <Icon name="MessageCircle" size={16} color="var(--color-primary)" />
          Contact Support Team
        </a>
      </div>
      {/* Copy Error Details */}
      <div className="mt-4">
        <button
          onClick={() => navigator.clipboard?.writeText(errorMessage)}
          className="text-xs text-muted-foreground hover:text-foreground transition-colors flex items-center justify-center gap-1 mx-auto"
        >
          <Icon name="Copy" size={12} />
          Copy error details for support
        </button>
      </div>
    </div>
  );
};

export default VerificationError;